import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAssetTimeZoneAsync } from '../../services/assetTimezone/assetTimezoneService';

export const fetchAssetTimezone = createAsyncThunk(
  'assetTimezone/fetchAssetTimezone',
  async (assetId: string, { rejectWithValue }) => {
    try {
      const data = await fetchAssetTimeZoneAsync(assetId);
      return data;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Failed to fetch asset timezone');
    }
  },
);

interface AssetTimezoneState {
  data: any;
  loading: boolean;
  error: string | null;
}

const initialState: AssetTimezoneState = {
  data: null,
  loading: false,
  error: null,
};

const assetTimezoneSlice = createSlice({
  name: 'assetTimezone',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssetTimezone.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAssetTimezone.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAssetTimezone.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default assetTimezoneSlice.reducer;
